module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"cs":{"AddToCart":{"button":"Přidat do košíku","variantRequired":"Prosím vyberte variantu","notAvailable":"Není skladem"}},"en":{"AddToCart":{"button":"Add to cart","variantRequired":"Please select a variant","notAvailable":"Not in stock"}}}')
  delete Component.options._Ctor
}
